module.exports = __webpack_public_path__ + "static/media/concert.f4a0f576.jpg";